import { useDispatch } from "react-redux";
import Mode from "../components/styles/Mode";
import cookies from "../utilities/Cookies";
import { updatedarkmode } from "../features/mode";
import { useEffect, useState } from "react";
import { Box, Container, Modal, Skeleton } from "@mui/material";
import Spacebox from "../components/Spacebox";
import string from "../utilities/Strings";
import Results from "../components/Results";
import Flexbox from "../components/Flexbox";
import Button from "../components/Button";
import '../css/form.css'
import '../css/result-page.css'
import { CheckRounded } from "@mui/icons-material";
// import { extractUTMParameters } from "../utilities/utils";
import algorithms from "../utilities/Algorithms";
import ProgressWithStatuses from "../components/ProgressForResults";
import { isMobile } from 'react-device-detect'
import { getCurrentHourET, initializeLeadConnector, saveTrustedFormCert } from "../utilities/utils";
import LiveChatWidget from "../components/scripts/LivechatAI";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '95%' : 600,
    maxHeight: isMobile ? '85dvh' : '100dvh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 0,
    borderRadius: 5,
    overflow: 'hidden',
    border: '2px solid #2059ebff !important'
};

// const iframe = `<iframe
//   src="https://app.livechatai.com/aibot-iframe/cmietv5my0001lb04ssnmozfh"
//   style="border:1px solid #EAEAEA"
//   width="100%"
//   height="680"
//   frameborder="0"
//   allow="microphone"
// ></iframe>`

const video_iframe = `<div style="height:300px; width: 100%; background: #f0f0f0;position:relative;border-radius: 0px 0px 5px 5px; overflow: hidden;"><iframe src="https://player.vimeo.com/video/1140526893?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="FDR - VSL 2 - v2_16-9_60s_CC"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>`


const ResultPage = () => {

    const dispatch = useDispatch()
    const currentHour = getCurrentHourET()

    const [firstname, setFirstname] = useState(null)
    const [, setLastname] = useState(null)
    const [, setEmail] = useState(null)
    const [, setPhone] = useState(null)
    const [contactId, setContactId] = useState(null)
    const [result, setResult] = useState()
    const [loading, setLoading] = useState(true)

    const [openModal, setOpenModal] = useState(false)


    const scrollToTop = () => window.scrollTo({ behavior: 'smooth', top: 0 })

    // const updateParent = (url) => {
    //     window.parent.postMessage(
    //         { type: 'trigger', url: url },
    //         'https://www.finaldebtrelief.com'
    //     );
    // };

    // updateParent(`https://www.finaldebtrelief.com/trusted-cert-url-turbo1?contact_id=${contactId}&first_name=${firstname}&last_name=${lastname}&email=${email}&phone=${phone}&source=debt-calculator&page=cl${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)

    const handleClick = () => {
        if (currentHour >= 8 && currentHour < 10) {
            // 8am to 9:59am Logic - voicemail sent, ask and show user call us and schedule a call prompt
            setOpenModal(true)
        } else if (currentHour >= 10 && currentHour < 18) {
            // 10am - 5:59pm - Call, schedule a call
            openChatWidget()
        } else if (currentHour >= 18 && currentHour < 24) {
            // 6pm - 11:45pm Logic - voicemail sent, ask and show user call us and schedule a call prompt
            setOpenModal(true)
        } else if (currentHour === 24 || (currentHour > 0 && currentHour <= 8)) {
            // schedule a call
            window.open('https://api.leadconnectorhq.com/widget/bookings/fdr-call', "_blank")
        }
    }

    const openChatWidget = () => {
        const chatWidgetHost = document.querySelector('#live-chat-ai-host')
        if (chatWidgetHost) {
            const shadowRoot = chatWidgetHost.shadowRoot

            if (shadowRoot) {
                const chatBtn = shadowRoot.querySelector('#live-chat-ai-button')
                if (chatBtn) {
                    chatBtn.click()
                    chatBtn.style.opacity = 0
                    chatBtn.style.visibility = "hidden"
                } else console.log('chat_btn_not_accessible')
            } else console.log("shadowroot_not_accessible")
        } else {
            console.log('not_found')
        }
    }

    const hideChtBtn = () => {
        let trials = 1
        const engine = setInterval(() => {
            const chatWidgetHost = document.querySelector('#live-chat-ai-host')
            if (chatWidgetHost) {
                const shadowRoot = chatWidgetHost.shadowRoot
                if (shadowRoot) {
                    const chatBtn = shadowRoot.querySelector('#live-chat-ai-button')
                    if (chatBtn) {
                        chatBtn.style.opacity = 0
                        chatBtn.style.visibility = "hidden"
                        clearInterval(engine)
                    }
                }
            } else {
                if (trials > 10)
                    clearInterval(engine)
                trials = trials + 1
            }
            console.log(trials)
            console.log('running')
        }, 1000);
    }

    const openCallScheduleModal = () => {
        if (currentHour >= 18 && currentHour < 24) {
            setTimeout(() => {
                setOpenModal(true)
            }, 25_000)
        }
    }


    useEffect(() => {
        scrollToTop()
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        openCallScheduleModal()

        const urlParams = new URLSearchParams(window.location.search)
        const contact_id = urlParams.get('contact_id')
        const first_name = urlParams.get('first_name')
        const last_name = urlParams.get('last_name')
        const email_ = urlParams.get('email')
        const phone_ = urlParams.get('phone')
        const result_ = urlParams.get('result')

        if (contact_id && first_name) {
            setContactId(contact_id)
            setFirstname(first_name)
            setLastname(last_name)
            setEmail(email_)
            setPhone(phone_)
            if (result_)
                setResult(JSON.parse(result_))
            else {
                const amount = urlParams.get('amount')
                if (amount) {
                    const res = algorithms.computeDebtPlan(parseFloat(amount))
                    setResult(res)
                }
            }
            const trusted_cert = urlParams.get('trusted_form_cert_url')
            saveTrustedFormCert(trusted_cert, contact_id)
            initializeLeadConnector(contact_id, first_name, last_name, email_, phone_)
        }

        // eslint-disable-next-line
    }, [])
    return (
        <Mode>
            <div className="result-page">
                {loading && (
                    <div>
                        <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                            <ProgressWithStatuses onComplete={() => {
                                setLoading(false)
                                hideChtBtn()
                            }} />
                        </Flexbox>
                    </div>
                )}
                {!loading && <div>
                    {!contactId && !firstname && (
                        <Container>
                            <div className="margin-auto" style={{ maxWidth: '400px', padding: '10px' }}>
                                <Skeleton variant="rounded" width={"100%"} height={200} />
                                <Spacebox padding="10px" />
                                <Skeleton variant="rounded" width={100} height={15} />
                                <Spacebox padding="10px" />
                                <Skeleton variant="rounded" width="100%" height={10} />
                                <Spacebox padding="5px" />
                                <Skeleton variant="rounded" width="100%" height={10} />
                                <Spacebox padding="5px" />
                                <Skeleton variant="rounded" width="100%" height={10} />
                                <Spacebox padding="5px" />
                                <Skeleton variant="rounded" width="100%" height={10} />
                                <Spacebox padding="5px" />
                                <Skeleton variant="rounded" width="100%" height={10} />
                            </div>
                        </Container>
                    )}
                    {contactId && firstname && (
                        <div className="margin-auto mid bg">
                            <div style={{ padding: 20 }}>
                                {(result) && <div>
                                    <span style={{ fontWeight: '700' }} className="text-primary bold heading">See results below</span>
                                    {/* custom debt calculator message  */}
                                    <div>
                                        <Spacebox padding="10px" />
                                        <Results result={result} />
                                        <Spacebox padding="10px" />
                                        <div style={{ background: '#ff000010', padding: '10px' }}>
                                            <Flexbox alignItems="center" justifyContent="center">
                                                <span>
                                                    <b className="trade-red">
                                                        Please watch the complete video before getting on the call.
                                                    </b>
                                                </span>
                                            </Flexbox>
                                        </div>
                                    </div>
                                </div>}
                                <div dangerouslySetInnerHTML={{ __html: video_iframe }}></div>
                                <Spacebox padding="5px" />
                                <span style={{ fontWeight: '700', fontSize: 30 }} className="text-primary heading bold"><span className="text-black">{string.capitalise(firstname)},</span> ready to <u>take action</u>?</span>
                                <Spacebox padding="15px" />
                                <div>
                                    <span>
                                        <b className="bold">Lock in your savings</b> today and get a personalized debt relief plan. Others are securing theirs right now. <b className="bold">Don't miss</b> your chance to take control of your debt. <br /><br />
                                        Every day you delay is another day of interest and fees. <br /> <b className="bold">Take the next step now.</b>
                                    </span>
                                    <Spacebox padding="10px" />
                                    <Flexbox alignItems="center" justifyContent="center">
                                        <Button
                                            handleClick={() => handleClick()}
                                            className="signature-btn"
                                            style={{ background: 'var(--secondary)', color: 'white', width: 'fit-content', padding: '10px 30px', borderRadius: '100px', fontSize: '1.1rem' }}
                                        >
                                            Lock in my Savings Now
                                        </Button>
                                    </Flexbox>
                                    <Spacebox padding="10px" />
                                    <Flexbox justifyContent="center">
                                        <small className="terms" style={{ opacity: .5 }}>
                                            <b>We value your privacy.</b> By clicking the button above you consent to having your credit report accessed as explained underneath. This will not impact your credit. You understand that by clicking on the button above, you are providing written instructions to our <u>partner/ affiliates<span>TurboDebt, Clear One Advantage, Beyond Finance LLC, First Choice Debt Relief, National Debt Relief and Cura Debt</span></u> under the Fair Credit Reporting Act authorizing them to obtain information from your personal credit report or other information from a credit bureau solely for debt settlement.
                                        </small>
                                    </Flexbox>
                                    <Spacebox padding="10px" />
                                    <Flexbox justifyContent="center">
                                        <img src="/assets/trustedSites.png" alt="trusted-site" style={{ width: 250, display: 'block', margin: 'auto' }} />
                                    </Flexbox>
                                    <Spacebox padding="20px" />
                                </div>
                            </div>
                            {(currentHour >= 10 && currentHour < 18) && <LiveChatWidget />}
                        </div>
                    )}
                </div>}
                <Modal
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                >
                    <Box sx={style}>
                        <div style={{ padding: '20px' }}>
                            <span style={{ fontWeight: '700', color: '#2059ebff', fontSize: '28px' }} className="text-primary bold heading">It seems we just missed you!</span>
                            <Spacebox padding="10px" />
                            <div style={{ padding: '10px 30px', backgroundColor: '#eb202012', borderRadius: '10px' }}>
                                <span style={{ display: 'block', textAlign: 'center', lineHeight: '30px', color: '#eb2020ff' }}>
                                    <b className="bold">Hey {firstname}, Our agents just tried to call you, but missed you</b>, Please call this number <b>now</b> to lock in your savings. <br /><b><a href="tel:+12029987148" className="text-primary bold" style={{ fontSize: 23, color: '#eb2020ff', }}> 📞 (202) 998-7148</a></b>
                                </span>
                            </div>
                            <Spacebox padding="10px" />
                            <div style={{ padding: '10px 30px', backgroundColor: '#205aeb1b', borderRadius: '10px'}}>
                                <span style={{ display: 'block', textAlign: 'center', lineHeight: '30px', color: '#2059ebff'}} className="text-primary">
                                    If you can't chat now, please click here to schedule a call. <br /><b><a rel="noreferrer" target="_blank" href="https://api.leadconnectorhq.com/widget/bookings/fdr-call" className="bold" style={{ fontSize: 23, color: '#2059ebff', }}>
                                    📆 Schedule A Call    
                                    </a></b>
                                </span>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>
        </Mode>
    );
}

export default ResultPage;